import React from 'react';
import '../../assets/styles/component/button/themeToggle.css';
import { useTheme } from '../../context/themeContext';
import Icon from './icon';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    const handleToggle = () => {
        if (window.themeManager && window.themeManager.switchToManualMode && window.themeManager.getThemeMode) {
            // Check current theme mode
            const currentMode = window.themeManager.getThemeMode();

            if (currentMode === 'auto') {
                // If in auto mode, switch to manual mode with opposite theme
                const newTheme = theme === 'light' ? 'dark' : 'light';
                window.themeManager.switchToManualMode(newTheme);
            } else {
                // If already in manual mode, toggle the theme manually
                const currentTheme = window.themeManager.getCurrentTheme();
                const newTheme = currentTheme === 'light' ? 'dark' : 'light';
                window.themeManager.switchToManualMode(newTheme);
            }
        } else {
            // Fallback to original toggle if themeManager not available
            toggleTheme();
        }
    };

    return (
        <button
            onClick={handleToggle}
            className="theme-toggle-btn"
            aria-label="Toggle Dark Mode"
        >
            {theme === 'light' ? (
                <Icon name="Moon" />
            ) : (
                <Icon name="Sun" />
            )}
        </button>
    );
};

export default ThemeToggle;